import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#9d6f32',       // Swarna gold
      light: '#b8893f',
      dark: '#7a5525',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#7a5525',
      contrastText: '#ffffff',
    },
    background: {
      default: '#f9f9f8',
      paper: '#ffffff',
    },
    text: {
      primary: '#1a1a1a',
      secondary: '#6b6b6b',
    },
    divider: '#e8e8e8',
  },
  typography: {
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    h1: { fontFamily: "'Georgia', 'Times New Roman', serif" },
    h2: { fontFamily: "'Georgia', 'Times New Roman', serif" },
    h3: { fontFamily: "'Georgia', 'Times New Roman', serif" },
    h4: { fontFamily: "'Georgia', 'Times New Roman', serif" },
    h5: { fontFamily: "'Georgia', 'Times New Roman', serif" },
    h6: { fontFamily: "'Georgia', 'Times New Roman', serif" },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    // Buttons — gold filled, gold outlined
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 8,
          boxShadow: 'none',
          '&:hover': { boxShadow: 'none' },
        },
        containedPrimary: {
          backgroundColor: '#9d6f32',
          '&:hover': { backgroundColor: '#7a5525' },
        },
        outlinedPrimary: {
          borderColor: '#9d6f32',
          color: '#9d6f32',
          '&:hover': { borderColor: '#7a5525', backgroundColor: 'rgba(157,111,50,0.06)' },
        },
      },
    },
    // Tabs — gold active indicator
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          fontSize: 13,
          '&.Mui-selected': { color: '#9d6f32' },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: '#9d6f32',
        },
      },
    },
    // Checkboxes & Radio — gold
    MuiCheckbox: {
      styleOverrides: {
        root: {
          '&.Mui-checked': { color: '#9d6f32' },
          '&.MuiCheckbox-indeterminate': { color: '#9d6f32' },
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          '&.Mui-checked': { color: '#9d6f32' },
        },
      },
    },
    // Switch — gold when on
    MuiSwitch: {
      styleOverrides: {
        switchBase: {
          '&.Mui-checked': {
            color: '#9d6f32',
            '& + .MuiSwitch-track': { backgroundColor: '#9d6f32' },
          },
        },
      },
    },
    // TextField / Select focus — gold outline
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#9d6f32',
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          '&.Mui-focused': { color: '#9d6f32' },
        },
      },
    },
    // Chip — primary variant uses gold
    MuiChip: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: 'rgba(157,111,50,0.1)',
          color: '#9d6f32',
          border: '1px solid rgba(157,111,50,0.3)',
        },
      },
    },
    // Linear progress — gold
    MuiLinearProgress: {
      styleOverrides: {
        barColorPrimary: { backgroundColor: '#9d6f32' },
        colorPrimary: { backgroundColor: 'rgba(157,111,50,0.15)' },
      },
    },
    // Circular progress — gold
    MuiCircularProgress: {
      styleOverrides: {
        colorPrimary: { color: '#9d6f32' },
      },
    },
    // Stepper — gold active step
    MuiStepIcon: {
      styleOverrides: {
        root: {
          '&.Mui-active': { color: '#9d6f32' },
          '&.Mui-completed': { color: '#9d6f32' },
        },
      },
    },
    // Links — gold
    MuiLink: {
      styleOverrides: {
        root: { color: '#9d6f32' },
      },
    },
    // FAB — gold
    MuiFab: {
      styleOverrides: {
        primary: {
          backgroundColor: '#9d6f32',
          '&:hover': { backgroundColor: '#7a5525' },
        },
      },
    },
  },
});

export default theme;
